import { yupObject, validation } from 'utils/validation';

const { password, confirm_password } = validation.accountFields;

export const validationSchema = yupObject({
  password,
  confirm_password,
});
